var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconExperimence = function SvgIconExperimence(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_experimence_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.553 15.105a1 1 0 0 1 .895 1.789l-8 4a1 1 0 0 1-.895 0l-8-4a1 1 0 0 1 .895-1.79L12 18.88zm0-4a1 1 0 0 1 .895 1.789l-8 4a1 1 0 0 1-.895 0l-8-4a1 1 0 0 1 .895-1.79L12 14.88zm-7.781-8.078a1 1 0 0 1 .676.078l8 4a1 1 0 0 1 0 1.789l-8 4a1 1 0 0 1-.895 0l-8-4a1 1 0 0 1 0-1.79l8-4zM6.237 7.999 12 10.88 17.764 8 12 5.116z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.05,
    d: "M19.33 14.657a1.5 1.5 0 0 1 1.34 2.684l-8 4a1.5 1.5 0 0 1-1.34 0l-8-4a1.5 1.5 0 0 1 1.34-2.684L12 18.32zm0-4a1.5 1.5 0 0 1 1.34 2.684l-8 4a1.5 1.5 0 0 1-1.34 0l-8-4a1.5 1.5 0 0 1 1.34-2.684L12 14.32zM11.656 2.54a1.5 1.5 0 0 1 1.014.117l8 4a1.5 1.5 0 0 1 0 2.684l-8 4a1.5 1.5 0 0 1-1.342 0l-8-4a1.5 1.5 0 0 1 0-2.684l8-4 .056-.023.219-.078zM7.354 7.998 12 10.32l4.645-2.322L12 5.675z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_experimence_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconExperimence;